<button mat-button type="button" class="lang-trigger" [matMenuTriggerFor]="langMenu"
  [matTooltip]="isCollapsed ? currentLabel : ''" matTooltipPosition="right">
  <mat-icon class="lang-icon">translate</mat-icon>
  @if (!isCollapsed) {
  <span class="lang-code">{{ languageService.current() | uppercase }}</span>
  }
  @if (!isCollapsed) {
  <mat-icon class="lang-caret">arrow_drop_down</mat-icon>
  }
</button>

<mat-menu #langMenu="matMenu">
  @for (lang of languageService.availableLanguages; track lang.code) {
  <button mat-menu-item type="button" (click)="select(lang.code)">
    <mat-icon>{{ languageService.current() === lang.code ? 'check' : 'language' }}</mat-icon>
    <span>{{ lang.label }}</span>
  </button>
  }
</mat-menu>